// googleAnalyticsInit.tsx
import { useEffect, useRef } from 'react';
import { useSettings } from '../stateManagement/SettingsContext';
// import { useConsentStatus } from './hooks/useConsentStatus'; // your OneTrust hook
// import { initializeGA } from './ga';
import { log } from '../utils';

export const GoogleAnalyticsInit = () => {
  const { settings } = useSettings();
  const measurementId = settings?.configs.gaMeasurementId;
  const enableGoogleAnalytics = settings?.configs.enableGoogleAnalytics;
  const initialized = useRef(false);

  const PERFORMANCE_CONSENT_GROUP_ID = settings?.configs?.oneTrustGAConsentId;

  const hasPerformanceConsent = (): boolean => {
    const cookie = document.cookie.split('; ').find(c => c.startsWith('OptanonActiveGroups='));

    if (!cookie) return false;
    const groups = decodeURIComponent(cookie.split('=')[1]).split(',');
    if (PERFORMANCE_CONSENT_GROUP_ID) {
      return groups.includes(PERFORMANCE_CONSENT_GROUP_ID);
    }
    // eslint-disable-next-line
    console.warn('No OneTrust GA Consent ID configured');
    return false;
  };

  const tryInitializeGA = () => {
    if (initialized.current) return;
    if (!measurementId || !enableGoogleAnalytics) return;

    if (hasPerformanceConsent()) {
      // eslint-disable-next-line no-console
      // console.log('Test');
      log(settings?.configs.showLogs, 'Test');
    } else {
      // eslint-disable-next-line
      // console.log('GA not initialized — no performance consent yet');
      log(settings?.configs.showLogs, 'GA not initialized — no performance consent yet');
    }
    // initializeGA(measurementId);
    initialized.current = true;
  };

  useEffect(() => {
    tryInitializeGA();

    // Watch for changes in OneTrust consent
    const onConsentChanged = () => {
      tryInitializeGA();
    };

    window.addEventListener('OneTrustGroupsUpdated', onConsentChanged);

    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', onConsentChanged);
    };
  }, [measurementId, enableGoogleAnalytics]);

  return null;
};
